import { useQuery } from '@apollo/client';
import {
  Stack,
  Heading,
  IconTick,
  Card,
  IconChevron,
  Text,
  Strong,
  Box,
  TextLinkButton,
  ButtonLink,
  List,
} from 'braid-design-system';
import queryString from 'query-string';
import React from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';

import CustomLoader from 'src/components/CustomLoader/CustomLoader';
import { Error } from 'src/components/Error/Error';
import Routes from 'src/config/routes';
import {
  getMobileProductDetails,
  type MainListingProduct,
} from 'src/data/listing-products/mobile';
import { hasProductInfo } from 'src/data/listing-products/shared';
import { GetListingProductsForPaymentPageDocument } from 'src/generated/graphql';
import { clearSelectedProduct } from 'src/utils/cookies';
import { findListingProduct } from 'src/utils/listingProducts';

const SelectedProduct = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { productToken, listingId } = queryString.parseUrl(
    location.search,
  ).query;
  const { data, loading } = useQuery(GetListingProductsForPaymentPageDocument);

  if (loading) {
    return <CustomLoader />;
  }

  const listingProduct = findListingProduct(
    data?.listingProducts,
    productToken,
  );

  if (typeof listingId !== 'string' || !listingProduct) {
    return <Navigate to={Routes.PACKAGES} />;
  }

  if (!hasProductInfo(listingProduct)) {
    return <Error />;
  }

  const onSelectAnotherAdPackClick = () => {
    clearSelectedProduct();
    navigate(
      queryString.stringifyUrl({
        url: Routes.PACKAGES,
        query: { listingId },
      }),
    );
  };

  const paymentLink = queryString.stringifyUrl({
    url: Routes.PAYMENT,
    query: { listingId, productToken },
  });

  return (
    <Stack space="none">
      <Card>
        <Stack space="xlarge">
          <Heading level="2">Success!</Heading>
          <Stack space="medium">
            <Heading level="4">
              You chose a <Strong>{listingProduct.description}</Strong>
            </Heading>
            <List type="icon" icon={<IconTick tone="formAccent" />}>
              {getMobileProductDetails(
                // MainListingProduct is a fixed subset of ListingProductCode
                listingProduct.productCode as MainListingProduct,
              ).features.map((label, key) => (
                <Text key={key}>{label}</Text>
              ))}
            </List>
            <Box paddingLeft="large">
              <Stack space="medium">
                <Text>or</Text>
                <Text>
                  <TextLinkButton onClick={onSelectAnotherAdPackClick}>
                    Pick another ad pack <IconChevron direction="right" />
                  </TextLinkButton>
                </Text>
              </Stack>
            </Box>
          </Stack>
        </Stack>
      </Card>

      <ButtonLink href={paymentLink}>
        Next - Payment <IconChevron direction="right" />
      </ButtonLink>
    </Stack>
  );
};

export default SelectedProduct;
